{
  "common": {
    "loading": "Ładowanie...",
    "cancel": "Anuluj",
    "save": "Zapisz",
    "create": "Utwórz",
    "delete": "Usuń",
    "edit": "Edytuj",
    "view": "Zobacz",
    "back": "Wróć",
    "goBack": "Wróć",
    "yes": "Tak",
    "no": "Nie",
    "ok": "OK",
    "error": "Błąd",
    "success": "Sukces",
    "warning": "Ostrzeżenie",
    "info": "Informacja",
    "welcome": "Witaj",
    "capabilities": "Uprawnienia",
    "accessDenied": "Brak dostępu",
    "permissionDenied": "Nie masz uprawnień do tworzenia lub edytowania dronów.",
    "profile": "Profil",
    "lastLogin": "Ostatnie logowanie",
    "accountActivity": "Aktywność konta",
    "contactAdmin": "Skontaktuj się z administratorem w celu uzyskania dostępu do konta",
    "time": "Czas",
    "totalTime": "Całkowity czas",
    "notSet": "Nie ustawiono",
    "unknown": "Nieznany"
  },
  "nav": {
    "home": "Strona główna",
    "flights": "Loty",
    "drones": "Drony",
    "users": "Użytkownicy",
    "procedures": "Procedury i listy kontrolne",
    "tasks": "Zadania",
    "info": "Informacje i kontakt",
    "auditLogs": "Logi aplikacji"
  },
  "flights": {
    "title": "Loty",
    "newFlight": "Nowy lot",
    "logbook": "Dziennik lotów",
    "flightDetails": "Szczegóły lotu",
    "addFlight": "Dodaj lot",
    "editFlight": "Edytuj lot",
    "add": "Dodaj lot",
    "edit": "Edytuj lot",
    "delete": "Usuń lot",
    "category": "Kategoria",
    "operation": "Operacja",
    "activity": "Aktywność",
    "conditions": "Warunki",
    "pilot": "Pilot",
    "operator": "Operator",
    "noFlightsFound": "Nie znaleziono lotów",
    "tapAddFlightToStart": "Naciśnij \"Dodaj lot\", aby utworzyć pierwszy wpis w dzienniku",
    "errors": {
      "fetchFailed": "Nie udało się pobrać lotów"
    }
  },
  "drones": {
    "title": "Drony",
    "registry": "Rejestr dronów",
    "add": "Dodaj drona",
    "edit": "Edytuj drona",
    "addDrone": "Dodaj drona",
    "editDrone": "Edytuj drona",
    "droneDetails": "Szczegóły drona",
    "details": "Szczegóły drona",
    "viewDetails": "Zobacz szczegóły",
    "deleted": "USUNIĘTY",
    "restore": "Przywróć",
    "deleteTitle": "Usuń drona",
    "deleteConfirmation": "Czy na pewno chcesz usunąć \"{{name}}\"? Ta akcja może być cofnięta przez administratora.",
    "deleteSuccess": "Dron został pomyślnie usunięty",
    "restoreTitle": "Przywróć drona",
    "restoreConfirmation": "Czy na pewno chcesz przywrócić \"{{name}}\"?",
    "restoreSuccess": "Dron został pomyślnie przywrócony",
    "callSign": "Znak wywoławczy",
    "registration": "Rejestracja",
    "location": "Lokalizacja",
    "flightTime": "Czas lotu",
    "insurance": "Ubezpieczenie",
    "maxSpeed": "Maks. prędkość",
    "range": "Zasięg",
    "weight": "Waga",
    "maxWeight": "Maks. waga",
    "manufactured": "Wyprodukowany",
    "commissioned": "Wprowadzony do służby",
    "noDronesFound": "Nie znaleziono dronów",
    "addFirstDrone": "Dodaj swojego pierwszego drona używając przycisku 'Dodaj drona' powyżej",
    "noDronesAvailable": "Obecnie nie ma dostępnych dronów",
    "errors": {
      "fetchFailed": "Nie udało się pobrać dronów. Sprawdź konfigurację Firebase i spróbuj ponownie.",
      "deleteFailed": "Nie udało się usunąć drona",
      "restoreFailed": "Nie udało się przywrócić drona",
      "notFoundOrNoPermission": "Dron nie został znaleziony lub nie masz uprawnień do jego wyśwątlenia"
    }
  },
  "missions": {
    "title": "Misje",
    "newMission": "Nowa misja",
    "details": "Szczegóły misji"
  },
  "auth": {
    "signIn": "Zaloguj się",
    "signOut": "Wyloguj się",
    "email": "E-mail",
    "password": "Hasło",
    "login": "Logowanie",
    "loginWithGoogle": "Zaloguj się przez Google"
  },
  "settings": {
    "title": "Ustawienia",
    "language": "Język",
    "theme": "Motyw",
    "profile": "Profil"
  },
  "languages": {
    "pl": "Polski",
    "en": "English"
  },
  "users": {
    "title": "Użytkownicy",
    "management": "Zarządzanie użytkownikami",
    "manageRolesPermissions": "Zarządzaj rolami i uprawnieniami użytkowników",
    "accessDenied": "Dostęp zabroniony",
    "accessDeniedMessage": "Tylko administratorzy i menedżerowie mogą zarządzać użytkownikami.",
    "updateRole": "Zaktualizuj rolę użytkownika",
    "selectNewRole": "Wybierz nową rolę:",
    "roleUpdated": "Rola użytkownika została zaktualizowana na {{role}}",
    "viewDetails": "Zobacz szczegóły",
    "role": "Rola",
    "errors": {
      "fetchFailed": "Nie udało się pobrać użytkowników",
      "roleUpdateFailed": "Nie udało się zaktualizować roli użytkownika"
    }
  },
  "user": {
    "details": "Szczegóły użytkownika",
    "role": "Rola",
    "admin": "Administrator",
    "manager": "Menedżer",
    "user": "Użytkownik",
    "email": "E-mail",
    "firstName": "Imię",
    "lastName": "Nazwisko",
    "roles": {
      "admin": "ADMINISTRATOR",
      "manager": "MENEDŻER",
      "user": "UŻYTKOWNIK"
    }
  },
  "userForm": {
    "editTitle": "Edytuj użytkownika",
    "createTitle": "Utwórz użytkownika",
    "loading": "Ładowanie danych użytkownika...",
    "basicInfo": "Informacje podstawowe",
    "operatorInfo": "Informacje o operatorze",
    "pilotInfo": "Informacje o pilocie",
    "licenseInfo": "Informacje o licencji",
    "qualifications": "Kwalifikacje / Uprawnienia",
    "qualificationsSubtitle": "Wybierz odpowiednie kwalifikacje (wymagana co najmniej jedna):",
    "email": "E-mail",
    "emailPlaceholder": "Wprowadź adres e-mail",
    "firstName": "Imię",
    "firstNamePlaceholder": "Wprowadź imię",
    "surname": "Nazwisko",
    "surnamePlaceholder": "Wprowadź nazwisko",
    "phone": "Telefon",
    "phonePlaceholder": "Wprowadź numer telefonu",
    "address": "Adres zamieszkania",
    "addressPlaceholder": "Wprowadź adres zamieszkania",
    "language": "Język",
    "languagePlaceholder": "Wybierz język",
    "role": "Rola",
    "rolePlaceholder": "Wybierz rolę",
    "operatorNumber": "Numer operatora",
    "operatorNumberPlaceholder": "Wprowadź numer operatora",
    "operatorValidityDate": "Data ważności uprawnień operatora",
    "pilotNumber": "Numer pilota",
    "pilotNumberPlaceholder": "Wprowadź numer pilota",
    "pilotValidityDate": "Data ważności uprawnień pilota",
    "licenseConversionNumber": "Numer konwersji licencji lub numer decyzji administracyjnej",
    "licenseConversionPlaceholder": "Wprowadź numer konwersji licencji",
    "insurance": "Data ważności ubezpieczenia",
    "insuranceDate": "Data ważności ubezpieczenia",
    "insuranceDatePlaceholder": "Wprowadź datę ważności ubezpieczenia",
    "updateButton": "Zaktualizuj",
    "createButton": "Utwórz",
    "updateSuccess": "Użytkownik został pomyślnie zaktualizowany",
    "createSuccess": "Użytkownik został pomyślnie utworzony",
    "saveError": "Nie udało się zapisać danych użytkownika",
    "success": "Sukces",
    "userUpdated": "Dane użytkownika zostały pomyślnie zaktualizowane",
    "validation": {
      "title": "Błąd walidacji",
      "message": "Proszę poprawić wyróżnione pola i spróbować ponownie.",
      "emailRequired": "E-mail jest wymagany",
      "firstNameRequired": "Imię jest wymagane",
      "surnameRequired": "Nazwisko jest wymagane",
      "operatorOrPilotRequired": "Wymagany jest numer operatora lub numer pilota",
      "qualificationsRequired": "Musi być wybrana co najmniej jedna kwalifikacja/uprawnienie",
      "emailInvalid": "Wprowadź poprawny adres e-mail.",
      "firstnameRequired": "Imię jest wymagane.",
      "roleRequired": "Rola jest wymagana.",
      "languageRequired": "Język jest wymagany.",
      "languageInvalid": "Wybrany język jest nieprawidłowy.",
      "phoneInvalid": "Wprowadź poprawny numer telefonu.",
      "dateInvalid": "Użyj formatu daty RRRR-MM-DD.",
      "qualificationsInvalid": "Wybrana kwalifikacja jest nieprawidłowa."
    }
  },
  "userDetails": {
    "title": "Szczegóły użytkownika",
    "basicInfo": "Informacje podstawowe",
    "contactInfo": "Informacje kontaktowe",
    "operatorInfo": "Informacje o operatorze",
    "pilotInfo": "Informacje o pilocie",
    "licenseInfo": "Informacje o licencji",
    "qualifications": "Kwalifikacje",
    "accountInfo": "Informacje o koncie",
    "editButton": "Edytuj profil",
    "noPhone": "Nie podano",
    "noAddress": "Nie podano",
    "noData": "Brak danych",
    "notFound": "Użytkownik nie został znaleziony",
    "loadError": "Nie udało się załadować szczegółów użytkownika"
  },
  "flightDetails": {
    "title": "Szczegóły lotu",
    "basicInfo": "Informacje podstawowe",
    "operationalInfo": "Informacje operacyjne",
    "auditInfo": "Informacje audytowe",
    "editButton": "Edytuj lot",
    "deleteButton": "Usuń lot",
    "category": "Kategoria",
    "operation": "Operacja",
    "activity": "Aktywność",
    "conditions": "Warunki",
    "drone": "Dron",
    "pilot": "Pilot",
    "operator": "Operator",
    "duration": "Czas trwania",
    "location": "Lokalizacja",
    "coordinates": "Współrzędne",
    "viewOnMap": "Zobacz na mapie Google",
    "date": "Data",
    "createdBy": "Utworzony przez",
    "updatedBy": "Zaktualizowany przez",
    "createdAt": "Data utworzenia",
    "updatedAt": "Data aktualizacji",
    "deleteConfirmTitle": "Usuń lot",
    "deleteConfirmMessage": "Czy na pewno chcesz usunąć ten lot? Ta akcja nie może być cofnięta.",
    "deleteSuccess": "Lot został pomyślnie usunięty",
    "deleteError": "Nie udało się usunąć lotu",
    "notFound": "Lot nie został znaleziony lub nie masz uprawnień do jego wyświetlenia",
    "loadError": "Nie udało się pobrać szczegółów lotu"
  },
  "flightForm": {
    "editTitle": "Edytuj lot",
    "createTitle": "Nowy lot",
    "basicInfo": "Informacje podstawowe",
    "operationalInfo": "Informacje operacyjne",
    "category": "Kategoria",
    "categoryPlaceholder": "Wybierz kategorię",
    "operation": "Operacja",
    "operationPlaceholder": "Wybierz operację",
    "activity": "Aktywność",
    "activityPlaceholder": "Wybierz aktywność",
    "conditions": "Warunki",
    "conditionsPlaceholder": "Warunki pogodowe i lotu (opcjonalne)",
    "additionalInfo": "Dodatkowe informacje",
    "additionalInfoPlaceholder": "Wprowadź dodatkowe informacje o locie (opcjonalne)",
    "drone": "Dron",
    "dronePlaceholder": "Wybierz drona",
    "otherDrone": "Inny (wpis ręczny)",
    "customDroneName": "Nazwa niestandardowego drona",
    "customDroneNamePlaceholder": "Wprowadź nazwę drona",
    "operator": "Operator",
    "operatorPlaceholder": "Wybierz operatora",
    "duration": "Czas trwania (minuty)",
    "durationPlaceholder": "Wprowadź czas trwania",
    "location": "Lokalizacja",
    "locationPlaceholder": "Wprowadź lokalizację lotu",
    "coordinates": "Współrzędne",
    "coordinatesPlaceholder": "Wprowadź współrzędne (szer, dł)",
    "date": "Data",
    "datePlaceholder": "YYYY-MM-DD",
    "startDate": "Data rozpoczęcia",
    "startTime": "Czas rozpoczęcia",
    "startTimePlaceholder": "HH:mm (np. 14:30)",
    "endDate": "Data zakończenia",
    "endTime": "Czas zakończenia",
    "endTimePlaceholder": "HH:mm (np. 16:30)",
    "updateButton": "Zaktualizuj lot",
    "createButton": "Utwórz lot",
    "updateSuccess": "Lot został pomyślnie zaktualizowany",
    "createSuccess": "Lot został pomyślnie utworzony",
    "saveError": "Nie udało się zapisać lotu",
    "notFound": "Lot nie został znaleziony",
    "loadError": "Nie udało się pobrać danych lotu",
    "validation": {
      "title": "Błąd walidacji",
      "message": "Proszę wypełnić wszystkie wymagane pola.",
      "categoryRequired": "Kategoria jest wymagana",
      "operationRequired": "Operacja jest wymagana",
      "activityRequired": "Aktywność jest wymagana",
      "conditionsRequired": "Warunki są wymagane",
      "droneRequired": "Dron jest wymagany",
      "operatorRequired": "Operator jest wymagany",
      "durationRequired": "Czas trwania jest wymagany",
      "locationRequired": "Lokalizacja jest wymagana",
      "coordinatesRequired": "Koordynaty są wymagane",
      "dateRequired": "Data jest wymagana",
      "droneIdRequired": "Dron jest wymagany",
      "startDateRequired": "Data rozpoczęcia jest wymagana",
      "startTimeRequired": "Czas rozpoczęcia jest wymagany",
      "endDateRequired": "Data zakończenia jest wymagana",
      "endTimeRequired": "Czas zakończenia jest wymagany",
      "flightCategoryRequired": "Kategoria lotu jest wymagana",
      "operationTypeRequired": "Typ operacji jest wymagany",
      "activityTypeRequired": "Typ aktywności jest wymagany",
      "noDronesAvailable": "Brak dostępnych dronów. Proszę najpierw dodać drony.",
      "selectValidDrone": "Proszę wybrać prawidłowy dron",
      "customDroneNameRequired": "Nazwa niestandardowego drona jest wymagana",
      "dateFormat": "Data musi być w formacie YYYY-MM-DD",
      "startDateFormat": "Data rozpoczęcia musi być w formacie YYYY-MM-DD",
      "endDateFormat": "Data zakończenia musi być w formacie YYYY-MM-DD",
      "startTimeFormat": "Czas rozpoczęcia musi być w formacie HH:mm",
      "endTimeFormat": "Czas zakończenia musi być w formacie HH:mm",
      "invalidDateTime": "Nieprawidłowy format daty/czasu",
      "endAfterStart": "Czas zakończenia musi być późniejszy niż czas rozpoczęcia",
      "maxDuration24Hours": "Czas trwania lotu nie może przekroczyć 24 godzin"
    }
  },
  "droneDetails": {
    "title": "Szczegóły drona",
    "basicInfo": "Informacje podstawowe",
    "technicalInfo": "Informacje techniczne",
    "operationalInfo": "Informacje operacyjne",
    "batteryInfo": "Informacje o baterii",
    "manufacturingInfo": "Informacje o produkcji",
    "documentation": "Dokumentacja",
    "images": "Zdjęcia",
    "auditInfo": "Informacje audytowe",
    "editButton": "Edytuj drona",
    "deleteButton": "Usuń drona",
    "restoreButton": "Przywróć drona",
    "name": "Nazwa",
    "model": "Model",
    "serialNumber": "Numer seryjny",
    "callSign": "Znak wywoławczy",
    "registration": "Numer seryjny drona",
    "equipmentRegistration": "Numer seryjny aparatury/kontrolera",
    "manufacturer": "Producent",
    "weight": "Waga",
    "maxWeight": "Maksymalna waga startowa",
    "maxSpeed": "Maksymalna prędkość",
    "range": "Zasięg",
    "flightTime": "Całkowity czas lotu",
    "operatingTime": "Czas pracy",
    "location": "Lokalizacja",
    "insurance": "Ubezpieczenie",
    "manufactured": "Rok produkcji",
    "commissioned": "Rok wprowadzenia do służby",
    "status": "Status",
    "deleted": "USUNIĘTY",
    "active": "AKTYWNY",
    "dimensions": "Wymiary",
    "batteryType": "Typ",
    "batteryCapacity": "Pojemność",
    "batteryVoltage": "Napięcie",
    "openManual": "Otwórz instrukcję obsługi",
    "deletedAt": "Usunięty",
    "deleteConfirmTitle": "Usuń drona",
    "deleteConfirmMessage": "Czy na pewno chcesz usunąć \"{{name}}\"? Ta akcja może być cofnięta przez administratora.",
    "restoreConfirmTitle": "Przywróć drona",
    "restoreConfirmMessage": "Czy na pewno chcesz przywrócić \"{{name}}\"?",
    "deleteSuccess": "Dron został pomyślnie usunięty",
    "restoreSuccess": "Dron został pomyślnie przywrócony",
    "deleteError": "Nie udało się usunąć drona",
    "restoreError": "Nie udało się przywrócić drona",
    "manualError": "Nie udało się otworzyć instrukcji obsługi",
    "notFound": "Dron nie został znaleziony",
    "loadError": "Nie udało się pobrać szczegółów drona"
  },
  "droneForm": {
    "editTitle": "Edytuj drona",
    "createTitle": "Nowy dron",
    "basicInfo": "Informacje podstawowe",
    "technicalInfo": "Informacje techniczne",
    "operationalInfo": "Informacje operacyjne",
    "namePlaceholder": "Wprowadź nazwę drona",
    "model": "Model",
    "modelPlaceholder": "Wprowadź model drona",
    "serialNumber": "Numer seryjny",
    "serialNumberPlaceholder": "Wprowadź numer seryjny",
    "callSign": "Znak wywoławczy",
    "callSignPlaceholder": "Wprowadź znak wywoławczy",
    "inventoryCode": "Kod inwentarzowy",
    "inventoryCodePlaceholder": "Wprowadź kod inwentarzowy",
    "registration": "Rejestracja",
    "registrationPlaceholder": "Wprowadź numer rejestracji",
    "manufacturer": "Producent",
    "manufacturerPlaceholder": "Wprowadź nazwę producenta",
    "weight": "Waga (g)",
    "weightPlaceholder": "Wprowadź wagę",
    "maxWeight": "Maksymalna waga (g)",
    "maxWeightPlaceholder": "Wprowadź maksymalną wagę",
    "maxSpeed": "Maksymalna prędkość (km/h)",
    "maxSpeedPlaceholder": "Wprowadź maksymalną prędkość",
    "range": "Zasięg (m)",
    "rangePlaceholder": "Wprowadź zasięg",
    "flightTime": "Czas lotu (min)",
    "flightTimePlaceholder": "Wprowadź czas lotu",
    "location": "Lokalizacja",
    "locationPlaceholder": "Wprowadź lokalizację",
    "insurance": "Data ważności ubezpieczenia",
    "insurancePlaceholder": "YYYY-MM-DD",
    "manufactured": "Data produkcji",
    "manufacturedPlaceholder": "YYYY-MM-DD",
    "commissioned": "Data wprowadzenia do służby",
    "commissionedPlaceholder": "YYYY-MM-DD",
    "updateButton": "Zaktualizuj drona",
    "createButton": "Utwórz drona",
    "updateSuccess": "Dron został pomyślnie zaktualizowany",
    "createSuccess": "Dron został pomyślnie utworzony",
    "saveError": "Nie udało się zapisać drona",
    "validation": {
      "title": "Błąd walidacji",
      "message": "Proszę wypełnić wszystkie wymagane pola.",
      "nameRequired": "Nazwa jest wymagana",
      "modelRequired": "Model jest wymagany",
      "serialNumberRequired": "Numer seryjny jest wymagany",
      "callSignRequired": "Znak wywoławczy jest wymagany",
      "inventoryCodeRequired": "Kod inwentarzowy jest wymagany",
      "registrationRequired": "Rejestracja jest wymagana",
      "manufacturerRequired": "Producent jest wymagany"
    },
    "title": "Drony",
    "addTitle": "Dodaj nowy dron",
    "loading": "Ładowanie danych drona...",
    "flightInfo": "Informacje o locie",
    "physicalSpecs": "Specyfikacje fizyczne",
    "batteryInfo": "Informacje o baterii",
    "manufacturingInfo": "Informacje o produkcji",
    "documentation": "Dokumentacja",
    "name": "Nazwa drona",
    "nameRequired": "Nazwa drona jest wymagana",
    "callSignRequired": "Znak wywoławczy jest wymagany",
    "registrationNumber": "Numer seryjny drona",
    "registrationRequired": "Numer seryjny drona jest wymagany",
    "equipmentRegistration": "Numer seryjny aparatury/kontrolera",
    "equipmentRegistrationPlaceholder": "Wprowadź numer seryjny aparatury/kontrolera",
    "totalFlightTime": "Całkowity czas lotu (minuty)",
    "operatingTime": "Czas pracy (minuty)",
    "maxTakeoffWeight": "Maksymalna waga startowa (gramy)",
    "length": "Długość (mm)",
    "width": "Szerokość (mm)",
    "height": "Wysokość (mm)",
    "batteryType": "Typ baterii",
    "batteryTypePlaceholder": "Wprowadź typ baterii",
    "capacity": "Pojemność (mAh)",
    "voltage": "Napięcie (V)",
    "yearOfManufacture": "Rok produkcji",
    "yearOfCommissioning": "Rok wprowadzenia do służby",
    "userManual": "URL instrukcji obsługi (opcjonalne)",
    "userManualPlaceholder": "https://...",
    "additionalInfo": "Dodatkowe informacje",
    "additionalInfoPlaceholder": "Wprowadź dodatkowe informacje o dronie (opcjonalne)",
    "images": "Zdjęcia",
    "cancel": "Anuluj",
    "updateDrone": "Zaktualizuj drona",
    "createDrone": "Utwórz drona",
    "validationError": "Błąd walidacji",
    "success": "Sukces",
    "error": "Błąd",
    "droneNotFound": "Dron nie został znaleziony",
    "cannotEditDeleted": "Nie można edytować usuniętego drona",
    "failedToLoad": "Nie udało się załadować danych drona",
    "droneUpdated": "Dron został pomyślnie zaktualizowany",
    "droneCreated": "Dron został pomyślnie utworzony",
    "failedToUpdate": "Nie udało się zaktualizować drona",
    "failedToCreate": "Nie udało się utworzyć drona",
    "shareable": "Dron współdzielony",
    "shareableDescription": "Pozwól użytkownikom rezerwować i używać tego drona"
  },
  "droneClaims": {
    "claimStatus": "Status posiadania",
    "viewHistory": "Zobacz historię",
    "ownedBy": "W posiadaniu: {{owner}}",
    "claimedSince": "Zgłoszony {{date}} o {{time}} ({{duration}})",
    "available": "Dostępny do zgłoszenia",
    "claimDrone": "Zgłoś posiadanie drona",
    "releaseClaim": "Zgłoś zwrot drona",
    "forceRelease": "Wymuś oznaczenie jako zwrócony",
    "adminOverride": "Nadpisanie administratora",
    "adminOverrideNotImplemented": "Funkcja nadpisywania administratora zostanie wkrótce zaimplementowana",
    "droneClaimedSuccess": "Dron został pomyślnie zgłoszony",
    "droneReleasedSuccess": "Dron został pomyślnie zwolniony",
    "failedToClaim": "Nie udało się zgłosić posiadania drona",
    "failedToRelease": "Nie udało się zwolnić drona",
    "failedToLoadHistory": "Nie udało się załadować historii posiadania dronów",
    "claimHistory": "Historia posiadania",
    "noClaimHistory": "Brak historii posiadania",
    "active": "Aktywna",
    "completed": "Zakończona",
    "ongoing": "Trwająca",
    "claimPeriod": "{{start}} {{startTime}} - {{end}} {{endTime}} ({{duration}})",
    "userSearchError": "Nie udało się wyszukać użytkowników",
    "overridingFor": "Nadpisywanie rezerwacji dla",
    "currentOwner": "Obecnie w posiadaniu",
    "overrideOptions": "Opcje nadpisania",
    "endClaimOnly": "Zakończ tylko obecną rezerwację",
    "assignToNewUser": "Przypisz do nowego użytkownika",
    "searchUsers": "Szukaj użytkowników po nazwie lub e-mailu...",
    "selectUserFirst": "Najpierw wybierz użytkownika",
    "claimEndedSuccess": "Rezerwacja została pomyślnie zakończona",
    "overrideFailed": "Nie udało się nadpisać rezerwacji",
    "droneAssignedSuccess": "Dron został pomyślnie przypisany do {{user}}",
    "assignToDrone": "Przypisz do tego drona",
    "confirmClaim": "Potwierdź zgłoszenie",
    "confirmClaimMessage": "Czy na pewno chcesz zgłosić posiadanie {{droneName}}?",
    "confirmRelease": "Potwierdź zwrot",
    "confirmReleaseMessage": "Czy na pewno chcesz zgłosić zwrot {{droneName}}?",
    "assignDrone": "Przypisz drona"
  },
  "imageForm": {
    "permissionRequired": "Wymagane uprawnienia",
    "permissionDenied": "Wymagane są uprawnienia do kamery i biblioteki zdjęć, aby dodać zdjęcia.",
    "error": "Błąd",
    "failedToPickImage": "Nie udało się wybrać zdjęcia. Spróbuj ponownie.",
    "confirmDelete": "Usuń zdjęcie",
    "confirmDeleteMessage": "Czy na pewno chcesz usunąć to zdjęcie?",
    "addFirstImage": "Dodaj zdjęcie",
    "addImage": "Dodaj kolejne zdjęcie",
    "imageCount": "{{count}} z {{max}} zdjęć"
  },
  "dashboard": {
    "title": "GOPR UAV Ops Manager",
    "welcome": "Witaj",
    "capabilitiesTitle": "Uprawnienia",
    "accountActivity": "Aktywność konta",
    "lastLogin": "Ostatnie logowanie",
    "profileData": "Moje dane profilu",
    "basicInformation": "Informacje podstawowe",
    "operatorInfo": "Informacje operatora",
    "pilotInfo": "Informacje pilota",
    "additionalInfo": "Informacje dodatkowe",
    "qualifications": "Kwalifikacje / Uprawnienia",
    "profileManagement": "Zarządzanie profilem",
    "editMyData": "Edytuj moje dane",
    "menuInfo": "Użyj menu (☰), aby nawigować między różnymi sekcjami aplikacji.",
    "roleInfo": "Dodatkowe funkcjonalności związane z rolą są dostępne na podstawie Twoich uprawnień {{role}}.",
    "email": "Email",
    "firstName": "Imię",
    "surname": "Nazwisko",
    "phone": "Telefon",
    "residentialAddress": "Adres zamieszkania",
    "operatorNumber": "Numer operatora",
    "operatorValidityDate": "Data ważności uprawnień operatora",
    "pilotNumber": "Numer pilota",
    "pilotValidityDate": "Data ważności uprawnień pilota",
    "licenseConversion": "Numer konwersji licencji/decyzji administracyjnej",
    "insuranceDate": "Data ważności ubezpieczenia",
    "noQualifications": "Brak ustawionych kwalifikacji",
    "notSet": "Nie ustawiono",
    "capabilities": {
      "admin": [
        "Pełny dostęp do systemu",
        "Zarządzanie użytkownikami",
        "Wszystkie operacje",
        "Konfiguracja systemu"
      ],
      "manager": [
        "Zarządzanie operacjami",
        "Nadzór nad zespołem",
        "Przeglądanie raportów",
        "Ograniczone zarządzanie użytkownikami"
      ],
      "user": [
        "Podstawowe operacje",
        "Przeglądanie przypisanych zadań",
        "Aktualizacja statusu"
      ],
      "default": [
        "Ograniczony dostęp"
      ]
    },
    "navigation": {
      "flights": "Zarządzanie lotami",
      "drones": "Rejestr dronów",
      "procedures": "Procedury i listy kontrolne",
      "profile": "Mój profil",
      "users": "Zarządzanie użytkownikami",
      "tasks": "Zadania",
      "logs": "Logi aplikacji"
    }
  },
  "procedures": {
    "title": "Procedury/Checklisty",
    "allProcedures": "Wszystkie procedury",
    "viewAll": "Zobacz wszystkie",
    "loading": "Ładowanie procedury/listy kontrolnej...",
    "notFound": "Procedura/Lista kontrolna nie została znaleziona",
    "notFoundDescription": "Żądana procedura lub lista kontrolna nie mogła zostać znaleziona.",
    "goBack": "Wróć",
    "edit": "Edytuj",
    "deleted": "USUNIĘTY",
    "created": "Utworzono",
    "updated": "Zaktualizowano",
    "by": "przez",
    "items": "element",
    "itemsPlural": "elementów",
    "openLink": "Otwórz link",
    "openFile": "Otwórz plik",
    "deleteTitle": "Usuń procedurę/listę kontrolną",
    "deleteConfirmation": "Czy na pewno chcesz usunąć \"{{title}}\"? Ta akcja może być cofnięta przez administratora.",
    "deleteSuccess": "Procedura/lista kontrolna została pomyślnie usunięta",
    "deleteError": "Nie udało się usunąć procedury/listy kontrolnej",
    "restoreTitle": "Przywróć procedurę/listę kontrolną",
    "restoreConfirmation": "Czy na pewno chcesz przywrócić \"{{title}}\"?",
    "restoreSuccess": "Procedura/lista kontrolna została pomyślnie przywrócona",
    "restoreError": "Nie udało się przywrócić procedury/listy kontrolnej",
    "addNew": "Dodaj nową",
    "itemSingle": "element",
    "itemPlural": "elementów",
    "createdOn": "Utworzono {{date}}",
    "editProcedure": "Edycja procedury/checklisty",
    "searchPlaceholder": "Szukaj procedur...",
    "search": {
      "noResults": "Nie znaleziono procedur",
      "noResultsDescription": "Żadne procedury nie pasują do \"{{query}}\". Spróbuj dostosować wyszukiwane terminy.",
      "clearSearch": "Wyczyść wyszukiwanie"
    },
    "categories": {
      "title": "Procedury",
      "titleHeader": "Kategorie procedur"
    },
    "empty": {
      "title": "Brak procedur lub list kontrolnych",
      "descriptionCanCreate": "Utwórz swoją pierwszą procedurę lub listę kontrolną, aby rozpocząć.",
      "descriptionCannotCreate": "Nie utworzono jeszcze żadnych procedur ani list kontrolnych."
    },
    "delete": {
      "button": "Usuń",
      "title": "Usuń procedurę/listę kontrolną",
      "confirmMessage": "Czy na pewno chcesz usunąć \"{{title}}\"? Ta akcja może być cofnięta przez administratora.",
      "successMessage": "Procedura/lista kontrolna została pomyślnie usunięta",
      "errorMessage": "Nie udało się usunąć procedury/listy kontrolnej"
    },
    "restore": {
      "button": "Przywróć",
      "successMessage": "Procedura/lista kontrolna została pomyślnie przywrócona",
      "errorMessage": "Nie udało się przywrócić procedury/listy kontrolnej"
    },
    "errors": {
      "fetchFailed": "Nie udało się pobrać procedur/list kontrolnych"
    },
    "execute": {
      "button": "Wykonaj",
      "title": "Wykonaj procedurę",
      "step": "Krok {{current}} z {{total}}",
      "previous": "Poprzedni",
      "next": "Następny",
      "finish": "Zakończ",
      "started": "Rozpoczęto wykonywanie procedury",
      "completed": "Wykonywanie procedury zakończone",
      "markDone": "Oznacz jako wykonane",
      "markNotDone": "Odznacz wykonanie"
    },
    "subItems": {
      "control": "Kontrola",
      "requiredState": "Wymagany stan",
      "expandAll": "Rozwiń wszystkie",
      "collapseAll": "Zwiń wszystkie"
    }
  },
  "categories": {
    "title": "Kategorie",
    "loading": "Ładowanie kategorii...",
    "addNew": "Dodaj kategorię",
    "deleted": "USUNIĘTY",
    "createTitle": "Utwórz kategorię",
    "editTitle": "Edytuj kategorię",
    "empty": {
      "title": "Brak kategorii",
      "descriptionCanCreate": "Utwórz pierwszą kategorię, aby organizować procedury.",
      "descriptionCannotCreate": "Nie utworzono jeszcze żadnych kategorii.",
      "noCategories": "Brak dostępnych kategorii"
    },
    "notFound": {
      "title": "Kategoria nie została znaleziona",
      "description": "Żądana kategoria nie mogła zostać znaleziona."
    },
    "delete": {
      "title": "Usuń kategorię",
      "confirmMessage": "Czy na pewno chcesz usunąć \"{{name}}\"? Ta akcja może być cofnięta przez administratora.",
      "successMessage": "Kategoria została pomyślnie usunięta",
      "errorMessage": "Nie udało się usunąć kategorii"
    },
    "restore": {
      "button": "Przywróć",
      "successMessage": "Kategoria została pomyślnie przywrócona",
      "errorMessage": "Nie udało się przywrócić kategorii"
    },
    "create": {
      "successMessage": "Kategoria została pomyślnie utworzona"
    },
    "edit": {
      "successMessage": "Kategoria została pomyślnie zaktualizowana"
    },
    "form": {
      "name": "Nazwa",
      "namePlaceholder": "Nazwa kategorii",
      "nameRequired": "Nazwa kategorii jest wymagana",
      "description": "Opis",
      "descriptionPlaceholder": "Opis kategorii (opcjonalne)",
      "color": "Kolor",
      "order": "Kolejność",
      "orderPlaceholder": "0",
      "orderInvalid": "Kolejność musi być liczbą dodatnią",
      "orderHelp": "Kategorie z niższymi numerami kolejności pojawiają się pierwsze",
      "preview": "Podgląd",
      "previewMeta": "0 procedur",
      "errors": {
        "saveFailed": "Nie udało się zapisać kategorii"
      }
    },
    "errors": {
      "fetchFailed": "Nie udało się pobrać kategorii"
    }
  },
  "procedureForm": {
    "header": "Procedura/Checklista",
    "createTitle": "Utwórz nową procedurę/listę kontrolną",
    "editTitle": "Edytuj procedurę/listę kontrolną",
    "loading": "Ładowanie danych listy kontrolnej...",
    "title": "Tytuł",
    "titleRequired": "Tytuł jest wymagany",
    "titlePlaceholder": "Wprowadź tytuł procedury/listy kontrolnej",
    "description": "Opis",
    "descriptionPlaceholder": "Wprowadź opis (opcjonalne)",
    "checklistItems": "Elementy listy kontrolnej",
    "addItem": "Dodaj element",
    "noItemsYet": "Nie dodano jeszcze żadnych elementów",
    "clickAddItem": "Kliknij \"Dodaj element\", aby utworzyć pierwszy element listy kontrolnej",
    "item": "Element",
    "topic": "Temat",
    "topicRequired": "Temat jest wymagany",
    "topicPlaceholder": "Wprowadź temat/tytuł dla tego elementu",
    "content": "Treść",
    "contentRequired": "Treść jest wymagana",
    "contentPlaceholder": "Wprowadź szczegółową treść/instrukcje",
    "image": "Obraz",
    "addImage": "Dodaj obraz",
    "changeImage": "Zmień obraz",
    "removeImage": "Usuń",
    "link": "Link",
    "linkPlaceholder": "Wprowadź link zewnętrzny (opcjonalne)",
    "categories": "Kategorie",
    "create": "Utwórz",
    "update": "Zaktualizuj",
    "validationError": "Błąd walidacji",
    "atLeastOneItem": "Wymagany jest co najmniej jeden element listy kontrolnej",
    "allItemsMustHaveTopic": "Wszystkie elementy muszą mieć temat",
    "allItemsMustHaveContent": "Wszystkie elementy muszą mieć treść",
    "error": "Błąd",
    "failedToCreate": "Nie udało się utworzyć procedury/listy kontrolnej",
    "failedToUpdate": "Nie udało się zaktualizować procedury/listy kontrolnej",
    "failedToLoad": "Nie udało się załadować danych listy kontrolnej",
    "permissionRequired": "Wymagane uprawnienie",
    "permissionDenied": "Tylko menedżerowie i administratorzy mogą tworzyć lub edytować procedury/listy kontrolne.",
    "failedToPickImage": "Nie udało się wybrać obrazu",
    "success": "Sukces",
    "procedureCreated": "Procedura została utworzona pomyślnie",
    "procedureUpdated": "Procedura została zaktualizowana",
    "subItems": {
      "title": "Subelementy",
      "add": "Dodaj subelement",
      "addNested": "Dodaj zagnieżdżony subelement",
      "newSubItem": "Nowy subelement",
      "type": "Typ",
      "typeSimple": "Opis",
      "typeControl": "Kontrola",
      "control": "Kontrola",
      "controlPlaceholder": "Wprowadź opis kontroli",
      "requiredState": "Wymagany stan",
      "requiredStatePlaceholder": "Wprowadź wymagany stan",
      "confirmDelete": "Usuń subelement",
      "confirmDeleteMessage": "Czy na pewno chcesz usunąć ten subelement?"
    },
    "confirmDelete": "Usuń element",
    "confirmDeleteMessage": "Czy na pewno chcesz usunąć ten element?",
    "itemsRequired": "Wymagany jest co najmniej jeden element",
    "itemTopicRequired": "Element {{number}}: Temat jest wymagany",
    "itemContentRequired": "Element {{number}}: Treść jest wymagana"
  },
  "contact": {
    "title": "Informacje i kontakt",
    "about": "O aplikacji",
    "aboutDescription": "Aplikacja \"GOPR UAV Operations Manager\" została opracowana przez, aby pomóc w efektywnym monitorowaniu i zarządzaniu operacjami BSP oraz operatorami BSP.",
    "contactInfo": "Informacje kontaktowe",
    "company": "Firma",
    "companyName": "RedMed Software",
    "generalContact": "Kontakt ogólny",
    "technicalContact": "Kontakt techniczny",
    "applicationInfo": "Informacje o aplikacji",
    "versionInfo": "GOPR UAV Ops Manager v{{version}} ({{commitHash}})\nOpracowano dla Grupy Bieszczadzkiej GOPR",
    "cannotOpenLink": "Nie można otworzyć tego linku",
    "failedToOpenLink": "Nie udało się otworzyć linku"
  },
  "drawer": {
    "appTitle": "GOPR UAV Ops Manager",
    "editProfile": "Edytuj profil",
    "signOut": "Wyloguj się"
  },
  "offline": {
    "noConnection": "Brak połączenia z internetem - wyświetlanie danych z pamięci podręcznej",
    "viewingCachedData": "Wyświetlanie danych z pamięci podręcznej"
  },
  "sync": {
    "syncingData": "Synchronizacja danych w tle..."
  },
  "location": {
    "error": "Nie można pobrać lokalizacji. Spróbuj ponownie.",
    "errorTitle": "Błąd lokalizacji",
    "permissionDenied": "Brak uprawnień do lokalizacji. Włącz dostęp do lokalizacji w ustawieniach.",
    "timeout": "Żądanie lokalizacji przekroczyło limit czasu. Spróbuj ponownie.",
    "networkError": "Wystąpił błąd sieci podczas pobierania lokalizacji.",
    "getCurrentLocation": "Pobierz bieżącą lokalizację",
    "geocodingFallback": "Znaleziono lokalizację GPS, ale nie można było przekonwertować jej na czytelny adres. Używanie współrzędnych.",
    "loading": "Pobieranie lokalizacji..."
  },
  "map": {
    "title": "Wybór z mapy",
    "notImplemented": "Funkcja wyboru z mapy już wkrótce!",
    "selectLocation": "Dotknij mapę, aby wybrać lokalizację",
    "noLocationSelected": "Nie wybrano lokalizacji",
    "selectedCoordinates": "Wybrano:",
    "notAvailable": "Interaktywna mapa nie jest dostępna na tej platformie",
    "useCoordinatesInput": "Proszę użyć pola współrzędnych",
    "markerPlaced": "Marker ustawiony"
  },
  "equipment": {
    "title": "Wyposażenie",
    "list": "Lista wyposażenia",
    "item": "Element wyposażenia",
    "name": "Nazwa",
    "namePlaceholder": "Wprowadź nazwę wyposażenia",
    "quantity": "Ilość",
    "image": "Zdjęcie",
    "addImage": "Dodaj zdjęcie",
    "addItem": "Dodaj element wyposażenia",
    "removeItem": "Usuń element wyposażenia",
    "removeItemConfirm": "Czy na pewno chcesz usunąć \"{{name}}\"? Spowoduje to również usunięcie powiązanego zdjęcia.",
    "noEquipment": "Nie dodano jeszcze żadnych elementów wyposażenia",
    "addFirstItem": "Dodaj pierwszy element wyposażenia za pomocą przycisku powyżej",
    "noEquipmentInStorage": "Brak elementów wyposażenia w tym schowku",
    "addFirstItemToStorage": "Dodaj pierwszy element wyposażenia do tego schowka",
    "checklist": "Lista kontrolna wyposażenia",
    "checkEquipment": "Sprawdź wyposażenie",
    "items": "Elementy",
    "progress": "{{checked}} z {{total}} elementów sprawdzonych",
    "allItemsChecked": "Wszystkie elementy wyposażenia zostały sprawdzone!",
    "reset": "Resetuj",
    "checklistNote": "Ta lista kontrolna służy wyłącznie do osobistej weryfikacji i nie jest zapisywana.",
    "reportMissing": "Zgłoś braki",
    "reportMissingIntro": "Zgłaszam brakujące elementy wyposażenia:",
    "reportMissingNone": "Nie znaleziono braków w wyposażeniu.",
    "reportMissingNoDrone": "Nie można zgłosić braków — brak identyfikatora drona.",
    "validation": {
      "nameRequired": "Nazwa wyposażenia jest wymagana",
      "nameRequiredInStorage": "Nazwa wyposażenia jest wymagana w schowku \"{{storageName}}\"",
      "quantityRequired": "Ilość musi wynosić co najmniej 1",
      "quantityRequiredInStorage": "Ilość musi wynosić co najmniej 1 w schowku \"{{storageName}}\""
    }
  },
  "equipmentStorage": {
    "storage": "Schowek",
    "storages": "Schowki na wyposażenie",
    "name": "Nazwa schowka",
    "namePlaceholder": "np. Torba 1, Walizka A, Skrzynka narzędziowa",
    "addStorage": "Dodaj schowek",
    "removeStorage": "Usuń schowek",
    "removeStorageConfirm": "Czy na pewno chcesz usunąć schowek \"{{name}}\" i wszystkie jego elementy wyposażenia?",
    "noStorages": "Nie dodano jeszcze żadnych schowków",
    "addFirstStorage": "Dodaj pierwszy schowek za pomocą przycisku powyżej",
    "validation": {
      "nameRequired": "Nazwa schowka jest wymagana"
    }
  },
  "comments": {
    "title": "Komentarze",
    "addComment": "Dodaj komentarz",
    "cancel": "Anuluj",
    "noComments": "Brak komentarzy",
    "beFirstToComment": "Bądź pierwszym, który doda komentarz o tym dronie",
    "addCommentForm": {
      "title": "Dodaj komentarz",
      "contentPlaceholder": "Wprowadź swój komentarz...",
      "attachImages": "Załącz zdjęcia (opcjonalne)",
      "visibilityTitle": "Widoczność",
      "visibilityPublic": "Publiczny",
      "visibilityPublicDesc": "Widoczny dla wszystkich użytkowników",
      "visibilityHidden": "Ukryty",
      "visibilityHiddenDesc": "Widoczny tylko dla menedżerów i administratorów",
      "submitButton": "Dodaj komentarz",
      "submittingButton": "Dodawanie...",
      "characterCount": "{{current}}/{{max}}"
    },
    "deleteConfirm": {
      "title": "Usuń komentarz",
      "message": "Czy na pewno chcesz usunąć ten komentarz? Ta akcja nie może zostać cofnięta.",
      "delete": "Usuń",
      "cancel": "Anuluj"
    },
    "hideConfirm": {
      "title": "Ukryj komentarz",
      "message": "Czy na pewno chcesz ukryć ten komentarz?",
      "hide": "Ukryj",
      "cancel": "Anuluj"
    },
    "messages": {
      "commentAdded": "Komentarz dodany pomyślnie",
      "commentDeleted": "Komentarz usunięty pomyślnie",
      "addCommentError": "Nie udało się dodać komentarza. Spróbuj ponownie.",
      "deleteCommentError": "Nie udało się usunąć komentarza. Spróbuj ponownie.",
      "hideCommentError": "Nie udało się ukryć komentarza.",
      "offlineError": "Komentarze wymagają połączenia internetowego",
      "loadError": "Nie udało się wczytać komentarzy. Spróbuj ponownie.",
      "commentRemoved": "Ten komentarz został usunięty.",
      "loadingComments": "Ładowanie komentarzy...",
      "loadMoreComments": "Załaduj więcej komentarzy",
      "enterComment": "Proszę wprowadzić komentarz",
      "commentHidden": "Komentarz został ukryty."
    },
    "visibility": {
      "hidden": "Ukryty",
      "public": "Publiczny"
    },
    "actions": {
      "retry": "Ponów"
    }
  },
  "filters": {
    "showFilters": "Pokaż filtry",
    "hideFilters": "Ukryj filtry",
    "applyFilters": "Filtruj",
    "clearFilters": "Wyczyść",
    "startDate": "Data od:",
    "endDate": "Data do:",
    "category": "Kategoria:",
    "drone": "Dron:",
    "activity": "Aktywność:",
    "entityType": "Typ encji:",
    "action": "Akcja:",
    "pilotEmail": "E-mail pilota:",
    "userEmail": "E-mail użytkownika:",
    "all": "Wszystkie",
    "entityTypes": {
      "drone": "Dron",
      "flight": "Lot",
      "procedureChecklist": "Procedura/Lista",
      "user": "Użytkownik",
      "task": "Zadanie",
      "taskTemplate": "Szablon zadania"
    },
    "actions": {
      "create": "Utwórz",
      "edit": "Edytuj",
      "delete": "Usuń",
      "restore": "Przywróć",
      "view": "Podgląd",
      "login": "Logowanie",
      "assign": "Przypisz",
      "status_change": "Zmiana statusu",
      "self_assign": "Samodzielne przypisanie"
    }
  },
  "tasks": {
    "titleHeader": "Zadania",
    "taskDetails": "Szczegóły zadania",
    "createTask": "Utwórz zadanie",
    "editTask": "Edytuj zadanie",
    "createTemplate": "Utwórz szablon",
    "editTemplate": "Edytuj szablon",
    "templates": "Szablony",
    "noTasks": "Brak zadań",
    "noTemplates": "Brak szablonów",
    "unassigned": "Nieprzypisane",
    "myOpen": "Moje otwarte",
    "myFinished": "Moje zakończone",
    "allTasks": "Wszystkie zadania",
    "selfAssign": "Przypisz do siebie",
    "selfAssignTitle": "Przypisz zadanie do siebie",
    "selfAssignConfirmation": "Czy chcesz przypisać \"{{title}}\" do siebie?",
    "selfAssignSuccess": "Zadanie przypisane do Ciebie pomyślnie",
    "selfAssignHelp": "Gdy włączone, każdy użytkownik może przypisać to zadanie do siebie",
    "deleteTitle": "Usuń zadanie",
    "deleteConfirmation": "Czy na pewno chcesz usunąć \"{{title}}\"?",
    "deleteSuccess": "Zadanie usunięte pomyślnie",
    "deleteTemplateTitle": "Usuń szablon",
    "deleteTemplateConfirmation": "Czy na pewno chcesz usunąć szablon \"{{title}}\"?",
    "deleteTemplateSuccess": "Szablon usunięty pomyślnie",
    "createSuccess": "Zadanie utworzone pomyślnie",
    "updateSuccess": "Zadanie zaktualizowane pomyślnie",
    "createTemplateSuccess": "Szablon utworzony pomyślnie",
    "updateTemplateSuccess": "Szablon zaktualizowany pomyślnie",
    "statusUpdateSuccess": "Status zadania zaktualizowany pomyślnie",
    "title": "Tytuł",
    "titlePlaceholder": "Wprowadź tytuł zadania",
    "description": "Opis",
    "descriptionPlaceholder": "Wprowadź opis zadania",
    "status": "Status",
    "statusNotStarted": "Nie rozpoczęto",
    "statusInProgress": "W trakcie",
    "statusDone": "Zakończono",
    "statusNotFinished": "Nie ukończono",
    "statusUpdate": "Aktualizacja statusu",
    "statusUpdateText": "Notatki o aktualizacji statusu",
    "statusUpdatePlaceholder": "Wprowadź notatki o aktualizacji statusu...",
    "currentStatusUpdate": "Bieżące notatki o statusie",
    "updateStatus": "Zaktualizuj status",
    "selfSignEnabled": "Samodzielne przypisanie włączone",
    "assignTo": "Przypisz do",
    "assignedTo": "Przypisane do",
    "createdBy": "Utworzone przez",
    "attachToDrone": "Dołącz do drona",
    "attachToProcedure": "Dołącz do procedury",
    "attachedToDrone": "Dołączone do drona",
    "attachedToProcedure": "Dołączone do procedury",
    "noDrone": "Brak drona",
    "noProcedure": "Brak procedury",
    "created": "Utworzono",
    "started": "Rozpoczęto",
    "finished": "Zakończono",
    "details": "Szczegóły",
    "timeline": "Oś czasu",
    "useTemplate": "Użyj szablonu (opcjonalnie)",
    "selectTemplate": "Wybierz szablon...",
    "viewDetails": "Zobacz szczegóły",
    "errors": {
      "fetchFailed": "Nie udało się pobrać zadań",
      "fetchTemplatesFailed": "Nie udało się pobrać szablonów",
      "notFound": "Nie znaleziono zadania",
      "templateNotFound": "Nie znaleziono szablonu",
      "loadFailed": "Nie udało się załadować zadania",
      "loadTemplateFailed": "Nie udało się załadować szablonu",
      "loadDataFailed": "Nie udało się załadować danych",
      "createFailed": "Nie udało się utworzyć zadania",
      "updateFailed": "Nie udało się zaktualizować zadania",
      "deleteFailed": "Nie udało się usunąć zadania",
      "createTemplateFailed": "Nie udało się utworzyć szablonu",
      "updateTemplateFailed": "Nie udało się zaktualizować szablonu",
      "deleteTemplateFailed": "Nie udało się usunąć szablonu",
      "statusUpdateFailed": "Nie udało się zaktualizować statusu zadania",
      "selfAssignFailed": "Nie udało się samodzielnie przypisać zadania",
      "titleRequired": "Tytuł jest wymagany",
      "descriptionRequired": "Opis jest wymagany"
    }
  }
}